<template>
  <section>
    <!-- BEGIN BANNER SECTION -->
    <tr>
      <td>
        <img src="./../assets/images/banner.jpg" width="800" height="160" alt />
      </td>
    </tr>
    <!-- END BANNER SECTION -->
    <tr>
      <td>
        <table id="innerTable">
          <tr>
            <!-- BEGIN LOGIN SECTION -->
            <td id="leftColumn"></td>
            <!-- END LOGIN SECTION -->
            <!-- BEGIN MAIN CONTENT SECTION -->
            <td id="centerColumn" class="txtBody" valign="top">
              <app-main-content></app-main-content>
              <!-- BEGIN MAIN CONTENT SECTION -->
            </td>
            <td id="rightColumn" valign="top">
              <!-- BEGIN SIDEBAR SECTION -->
              <br />
              <app-sidebar></app-sidebar>
            </td>
            <!-- END SIDEBAR SECTION -->
          </tr>
        </table>
      </td>
    </tr>
  </section>
</template>
<script>
import MainContent from "./../components/MainContent.vue";
import Sidebar from "./../components/Sidebar.vue";
export default {
  name: "Home",
  components: {
    appMainContent: MainContent,
    appSidebar: Sidebar,
  }
};
</script>
